import { render, staticRenderFns } from "./print-old.vue?vue&type=template&id=37031fdb&"
import script from "./print-old.vue?vue&type=script&lang=js&"
export * from "./print-old.vue?vue&type=script&lang=js&"
import style0 from "./print-old.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports